import { UserPreferenceEnum } from "@shared/enums/common-data/user-preference.enum";
import { ColumnState } from "ag-grid-community";
import { InbondStorageFilterFormModel } from "../inbond-storage/inbond-storage-filter-form.model";
import { RedeliveryFilterFormModel } from "../redelivery/redelivery-filter-form.model";

export class UserPreferenceModel {
  inbondOperationsLayout?: TableLayoutModel | undefined;
  inbondAuditLayout?: TableLayoutModel | undefined;
  inbondCompletedLayout?: TableLayoutModel | undefined;
  redeliveryCompletedLayout?: TableLayoutModel | undefined;
  redeliveryPendingLayout?: TableLayoutModel | undefined;
}

export class TableLayoutModel {
  columnState: ColumnState[] | undefined;
  filters: RedeliveryFilterFormModel | InbondStorageFilterFormModel | undefined;
}

export class UserPreferenceConfig {
  static readonly inbondLayout = UserPreferenceEnum.inbondLayout;
  static readonly redeliveryLayout = UserPreferenceEnum.redeliveryLayout;
  static readonly userPreferenceInitialState: UserPreferenceModel = { inbondOperationsLayout: undefined };
}
